export { default } from "bullitttime-embermodelsgochips/adapters/activator";
